import type { DomainMapper } from '../types';

const global: DomainMapper = {
  countryCode: 'global',
  currency: 'EUR',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/GLOBAL.svg',
  languagePrimary: true,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-global.xml',
  storyblokBasePath: 'global',
  url: 'https://localhost:3011/global',
  algoliaIndex: 'b2b-global-en-GB-products',
  algoliaIndexAutocomplete: 'b2b-global-en-GB-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1623,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: false,
    storyblokBasePath: 'b2b',
    applicationId: 1623,
    algoliaIndex: 'b2b-global-en-GB-products',
    algoliaIndexAutocomplete: 'b2b-global-en-GB-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-global.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1486,
    algoliaIndex: 'b2c-global-en-GB-products',
    algoliaIndexAutocomplete: 'b2c-global-en-GB-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-global-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
} as DomainMapper;

export default global;
